import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CssBaseline from '@mui/material/CssBaseline';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import makeStyles from '@mui/styles/makeStyles';

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

}));

function ManageInventoryOptions(props) {

  const classes = useStyles();

  return (
    <div>

      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large">
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Manage Inventory
                </Typography>
        </Toolbar>
      </AppBar>
      <div className={classes.appBarSpacer}></div>
      <Container fixed>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" style={{ width: '100%' }} view={'received_products'} 
            onClick={props.optionMenuBtnOnClickHandler}>
            Receive Products
          </Button>
          </Grid>

          {props.returnProductPageSettings && (
            <Grid item xs={12}>
            <Button variant="contained" color="primary" style={{ width: '100%' }} view={'return_products'} onClick={props.optionMenuBtnOnClickHandler}>
            Return Products
            </Button>
            </Grid>
          )}
          
          <Grid item xs={12}>
            <Button variant="contained" color="primary" style={{ width: '100%' }} view={'record_actual_inventory'} onClick={props.optionMenuBtnOnClickHandler}>
            Record Actual Inventory
          </Button>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" style={{ width: '100%' }} view={'compute_reorder_quantity'} onClick={props.optionMenuBtnOnClickHandler}>
            Compute Reorder Quantities
          </Button>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" style={{ width: '100%' }} view={'view_sales_invoice_summary'} onClick={props.optionMenuBtnOnClickHandler}>
            View Sales Invoice Summary
          </Button>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" style={{ width: '100%' }} view={'view_inventory_summary'} onClick={props.optionMenuBtnOnClickHandler}>
            View Inventory Summary
          </Button>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" style={{ width: '100%' }} view={'transfer_inventory'} onClick={props.optionMenuBtnOnClickHandler}>
            Transfer Inventory
          </Button>
          </Grid>
        </Grid>
      </Container>

    </div>
  );
}

export default ManageInventoryOptions